import { Component, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginViewModel } from '../models-views/login.view.model';
import { AppCommon } from '../providers/app-common';
import { LoginService } from '../services/login.service';
import { BehaviorSubject } from 'rxjs';
import LoginModel from '../models/user.model';
declare const google: any;
@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [LoginViewModel]
})
export class LoginComponent {

  currentYear: number = new Date().getFullYear();
  isLoggedIn: boolean = false;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());

  constructor(private ngZone: NgZone, private router: Router, private route: ActivatedRoute,
    private vm: LoginViewModel, private loginService: LoginService) { }

  ngOnInit(): void {
    this.isLoggedIn = AppCommon.isLoggedIn();
    if (this.isLoggedIn) {
      const next = this.route.snapshot.queryParamMap.get('next') || '/app/dashboard';
      const decodedNext = decodeURIComponent(next);
      this.router.navigateByUrl(decodedNext);
    } else {
      setTimeout(() => {
        this.initializeGoogleSignIn();
      }, 500);
    }
  }

  initializeGoogleSignIn(): void {
    console.log("Initializing Google Sign In...")
    google.accounts.id.initialize({
      client_id: environment.google_oauth_client,
      callback: (response: any) => this.handleCredentialResponse(response)
    });
    google.accounts.id.renderButton(
      document.getElementById('google-signin-button'),
      { theme: 'outline', size: 'large' }  // customization attributes
    );
    google.accounts.id.prompt(); // also display the One Tap dialog
    //... render button and prompt (see next steps)
  }

  handleCredentialResponse(response: any): void {
    //... handle the credential response
    const credential = response.credential;
    this.sendResponseToBackend(credential);

  }

  sendResponseToBackend(credential: string) {
    this.vm.parentLoginComponent = this;
    this.vm.subscribeLogin(this.loginModel);
    this.vm.authenticate(credential);
  }

  loginSuccess() {
    this.loginService.setIsLoggedin(true);
    const next = this.route.snapshot.queryParamMap.get('next') || '/app/dashboard';
    const decodedNext = decodeURIComponent(next);
    this.router.navigateByUrl(decodedNext);
  }

}
